import { Globe } from 'lucide-react';
import {
  siDiscord,
  siFacebook,
  siGithub,
  siInstagram,
  siPatreon,
  siSpotify,
  siSubstack,
  siTelegram,
  siTiktok,
  siTwitch,
  siWhatsapp,
  siX,
  siYoutube,
} from 'simple-icons';

import type { PlatformKey } from '@peach/types/tutors/tutor-link.dto.js';

type SimpleIcon = { path: string; hex: string; title: string };

const SI: Partial<Record<PlatformKey, SimpleIcon>> = {
  instagram: siInstagram,
  tiktok: siTiktok,
  youtube: siYoutube,
  patreon: siPatreon,
  twitter: siX,
  spotify: siSpotify,
  substack: siSubstack,
  discord: siDiscord,
  telegram: siTelegram,
  whatsapp: siWhatsapp,
  // linkedin: not available in simple-icons (removed at LinkedIn's request) — falls back to Globe
  facebook: siFacebook,
  twitch: siTwitch,
  github: siGithub,
};

/** The platform's own brand colour, for tinting a glyph tile. Null for platforms
    simple-icons has no mark for (custom links, linkedin) — the caller picks a neutral. */
export function platformHex(platform: PlatformKey): string | null {
  return SI[platform] ? `#${SI[platform]!.hex}` : null;
}

interface PlatformIconProps {
  platform: PlatformKey;
  className?: string;
}

/** Brand glyph for a platform; falls back to a generic globe for custom links and linkedin. */
export function PlatformIcon({ platform, className = 'w-5 h-5' }: PlatformIconProps) {
  const icon = SI[platform];
  if (!icon) return <Globe className={className} aria-hidden="true" />;
  return (
    <svg
      role="img"
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d={icon.path} />
    </svg>
  );
}
